<template>
    <div id="alipay_accounts">
        <p class="title">选择到账支付宝</p>
        <van-icon name="cross" color="#000" @click="close" />
        <div class="accounts_area">
            <div class="account-item" v-for="(item,i) in selection.accountList" :key="i" :class="{'active': item.id == account_id}" @click="changeAccount(item)">
                <i class="icon-alipay"></i>
                <p class="name">{{ item.name }}</p>
                <p class="account">{{ item.account | plusX }}</p>
                <i class="icon icon-check"></i>
            </div>
            <div class="add_account" @click="gotoAddAccount"><i class="icon icon-plus"></i><span>添加支付宝提现</span></div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                account_id: this.selection.account_id,
            };
        },
        props: ['selection'],
        filters: {
            plusX(str) {
                var x = "****";
                if (str.length >= 6) {
                    return (
                        str.substring(0, 3) + x + str.substring(str.length - 4, str.length)
                    );
                } else {
                    return str;
                }
            },
        },
        computed: {

        },
        mounted() {

        },
        methods: {
            close() {
                this.$parent.handleClose()
            },
            changeAccount(item) {
                this.account_id = item.id;
                this.$emit('handleSuccess',{
                    account_id: this.account_id
                })
            },
            gotoAddAccount() {
                if(this.selection.accountList.length >= 5) {
                    this.$toast({
                        message: '最多添加5个支付宝账号',
                        duration: 2000,
                        zIndex: 100000,
                    })
                    return
                }
                this.$router.push({
                   name: 'bind.account'
                })
            },
        },
    };
</script>
<style lang="less" scoped>
    #alipay_accounts {
        padding: 2.6rem 1rem 0;
        background-color: #fbfbfb;
        position: relative;
        .van-icon {
            position: absolute;
            right: 1rem;
            top: 1.3rem;
            font-size: 2rem;
            cursor: pointer;
        }
        .title {
            font-size: 1.6rem;
            font-weight: bold;
            text-align: center;
            color: #000;
            margin-bottom: 1.4rem;
        }
        .accounts_area {
            background-color: #fff;
            border-radius: 1rem;
            padding: 0 1.8rem 2rem;
            .account-item {
                display: flex;
                align-items: center;
                padding: 2rem 0 1.4rem;
                border-bottom: 1px solid #f2f2f2;
                cursor: pointer;
                position: relative;
                .icon-alipay {
                    width: 2rem;
                    height: 2rem;
                    background: url(../../assets/bx/alipay.png) no-repeat 0 0;
                    background-size: 100% 100%;
                    margin-right: 1.2rem;
                }
                .name {
                    font-size: 1.6rem;
                    color: #000;
                    margin-right: 2rem;
                }
                .account {
                    font-size: 1.6rem;
                    color: #a4a4a4;
                }
                .icon-check {
                    width: 2rem;
                    height: 2rem;
                    background: url(../../assets/bx/checked.png) no-repeat 0 0;
                    background-size: 100% 100%;
                    position: absolute;
                    right: 0;
                    top: 2rem;
                    display: none;
                }
                &.active {
                    .icon-check {
                        display: block;
                    }
                }
            }
            .add_account {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                padding: 1.6rem 0;
                font-size: 1.6rem;
                color: #a4a4a4;
                cursor: pointer;
                .icon-plus {
                    width: 2rem;
                    height: 2rem;
                    background: url(../../assets/bx/add.png) no-repeat 0 0;
                    background-size: 100% 100%;
                    margin-right: 1rem;
                }
            }
        }
    }
</style>